import { useEffect, useRef } from 'react';
import { refrescarMisClientes } from '../services/productoresService';

// La corrida programada sincroniza el padrón cada hora. Si la última quedó más
// vieja que esto, entrar a la planilla la fuerza: el productor no tiene que
// esperar ni acordarse de tocar "Actualizar mis clientes" para ver un cliente
// que en el Sistema de Gestión Comercial ya es suyo.
const MAX_ANTIGUEDAD_MS = 5 * 60 * 1000;

const toMillis = (ts) => {
  if (!ts) return 0;
  if (typeof ts.toMillis === 'function') return ts.toMillis();
  if (ts instanceof Date) return ts.getTime();
  const parsed = new Date(ts).getTime();
  return Number.isNaN(parsed) ? 0 : parsed;
};

/**
 * Refresca el padrón del productor una vez por sesión, al entrar, si la última
 * sincronización con el SGC quedó vieja.
 *
 * Es silencioso a propósito: `productores/{email}` se lee por suscripción, así
 * que las cuentas nuevas aparecen solas en cuanto la función termina de
 * escribir. Si falla, la vista sigue con el padrón que ya tenía y queda el
 * botón manual de la pestaña "Mis Clientes".
 */
export const useRefrescoPadronAlEntrar = (user, productor) => {
  const yaPedido = useRef(false);

  useEffect(() => {
    if (yaPedido.current) return;
    if (!user || !productor || productor.active === false) return;

    const syncedAtMs = toMillis(productor.syncedAt);
    if (syncedAtMs && Date.now() - syncedAtMs < MAX_ANTIGUEDAD_MS) return;

    yaPedido.current = true;
    refrescarMisClientes(user).catch((error) => {
      console.warn('No se pudo refrescar el padrón al entrar:', error);
    });
  }, [user, productor]);
};
